<template>
    <div id="main">
        <div class="page mb-6">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            <span v-if="$route.params.id">{{ $t('editar-usuario') }}</span>
                            <span v-else>{{ $t('adicionar-usuario') }}</span>
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('colaborador') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'usuario-gerenciar-list' })">{{
                                        $t('gerenciar-usuarios')
                                    }}</a>
                                </li>
                                <li v-if="$route.params.id">
                                    <a aria-current="page">{{ $t('editar-usuario') }}</a>
                                </li>
                                <li v-else>
                                    <a aria-current="page">{{ $t('adicionar-usuario') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="promptChangeTab()"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>

                <!-- ABAS -->
                <ul class="nav nav-tabs" v-if="isUpdate">
                    <li
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                        :key="i"
                        v-for="(aba, i) in abas"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>
                <div>
                    <Geral 
                        v-show="abaSelecionada == 0"
                        v-if="!newToEdit"
                        @promptChangeTab="promptChangeTab()"
                        @isChanged="isChanged = $event"
                    />

                    <Parametrizacao
                        v-if="abaSelecionada == 1 && isUpdate"
                    />

                    <Campanha 
                        v-if="abaSelecionada == 2 && isUpdate"
                    />
                </div>
                <br />
            </div>
        </div>
    </div>
</template>

<script>
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import Geral from '@/components/colaborador/gerenciar-usuario/abas/Geral';
import Parametrizacao from '@/components/colaborador/gerenciar-usuario/abas/Parametrizacao';
import Campanha from '@/components/colaborador/gerenciar-usuario/abas/Campanha';
import { mapState } from 'vuex';

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == "usuario-gerenciar-new" && to.name == "usuario-gerenciar-edit") {
            this.isUpdate = true;

            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        next();
    },

    components: {
        Geral,
        Campanha,
        Parametrizacao,
        ContainerLoader,
    },
    data() {
        return {
            usuario: {
                idusuario: null,
                nome: null,
            },
            service: new GerenciarUsuariosService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            isUpdate: false,
            abas: ['geral', 'parametrizacoes', 'campanha'],
            abaSelecionada: 0,
            cantEdit: false,
            isChanged: false,
            newToEdit: false,
        };
    },
    mounted() {
        if (!this.$route.query.tela && this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    created() {
        let titulo = this.$route.params.id ? 'editar-usuario' : 'adicionar-usuario';
        this.permissao = this.hasPermissionAccess('admin', 'colaborador', 'usuario-gerenciar');
        if (this.$route.params.id) this.isUpdate = true;
        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: titulo },
            });
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        mapsIsHidden() {
            this.$store.dispatch('mapsIsHidden', { mapsIsHidden: !this.hide.mapsIsHidden });
        },
        changeTab(i) {
            this.abaSelecionada = i;
        },
        promptChangeTab() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.redirectToPage();
                    },
                });
            } else {
                this.redirectToPage();
            }
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;

            if (this.$route.query.tela) {
                if (this.$route.query.tela == 'cliente-transportadora' || this.$route.query.tela == 'cliente-vendedor') {
                    tempTela = `${this.$route.query.contexto}-cliente-dados-cadastrais-edit`
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query['id'] },
                            query: { 
                                dadoscadastrais: this.$route.query.dadoscadastrais, 
                                politicacomercial: this.$route.query.politicacomercial, 
                                analisecomercial: this.$route.query.analisecomercial, 
                            },
                        });
                    }, 1000);
                } else if(this.$route.query.tela == 'empresa-usuario') {
                    console.log("contexto:", this.$route.query.contexto);
                    tempTela = `${this.$route.query.contexto}-empresa-dados-cadastrais-edit`;
                } else if(this.$route.query.tela == 'grupo-produto-usuario'){
                    tempTela = `${this.$route.query.contexto}-produto-grupo-edit`;
                } else if (this.$route.query.tela == 'agro-sugestao-new') {
                    tempTela = 'agro-sugestao-new';
                }else if (this.$route.query.tela == 'tabelapreco-usuario') {
                    tempTela = `${this.$route.query.contexto}-tabelapreco-edit`;
                    tempAba = 'usuarios';
                }else if (this.$route.query.tela == 'ven-funil-edit') {
                    tempTela = 'ven-funil-edit';
                    tempAba = 'colaborador';
                }else {
                    tempTela = this.$route.query.tela;
                    tempAba = this.$route.query.abaSelecionada;
                }
                let query = {};
                if(this.$route.query.dadoscadastrais) query.dadoscadastrais = this.$route.query.dadoscadastrais;
                if(this.$route.query.politicacomercial) query.politicacomercial = this.$route.query.politicacomercial;
                if(this.$route.query.analisecomercial) query.analisecomercial = this.$route.query.analisecomercial;
                if(tempAba!=null) query.abaSelecionada = tempAba;

                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query['id'] },
                        query: query,
                    });
                }, 1000);
            } else {
                this.$router.push({ name: 'usuario-gerenciar-list' });
            }
        },
    }
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    input {
        text-transform: none;
    }
    .page {
        position: relative;
        padding-left: 0;
        display: block;
        clear: both;
    }
    .nav.nav-tabs {
        margin-bottom: 5px;
        margin-top: 5px;
    }
}
</style>
